import React, { useEffect } from 'react'
import { ScrollView, TouchableOpacity, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon } from '@src/components/base/Icon'
import { Text } from '@src/components/base/Text'
import { Analytics } from '@src/config'
import { useWeightLossExperience } from './context'

export const PersonalPlan = () => {
  const { showBackButton, stepConfig, goToPreviousStep } = useWeightLossExperience()
  const styles = useStyleSheet(themedStyles)
  const insets = useSafeAreaInsets()

  useEffect(() => {
    if (!stepConfig) {
      return
    }

    Analytics.track(stepConfig.trackEvent)
  }, [stepConfig])

  if (!stepConfig) {
    return null
  }

  const StepScreen = stepConfig.screen

  return (
    <View style={styles.topLevelContainer}>
      <ScrollView
        bounces={false}
        contentContainerStyle={[styles.container, { paddingBottom: Math.max(insets.bottom, 16) }]}
      >
        {showBackButton && (
          <TouchableOpacity
            onPress={goToPreviousStep}
            accessibilityLabel="Back"
            style={styles.backButton}
          >
            <Icon name="caret-left" size={20} />
          </TouchableOpacity>
        )}

        {stepConfig.title && (
          <Text type="title-1" style={[styles.title, { marginTop: showBackButton ? 0 : 24 }]}>
            {stepConfig.title}
          </Text>
        )}

        <View style={{ justifyContent: 'space-between', flexGrow: 1 }}>
          <StepScreen />
        </View>
      </ScrollView>
    </View>
  )
}

const themedStyles = StyleService.create({
  topLevelContainer: {
    flex: 1,
    backgroundColor: 'theme.background',
  },
  container: {
    flexGrow: 1,
    paddingTop: 60,
    paddingHorizontal: 16,
    paddingBottom: 16,
  },
  backButton: {
    width: 40,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: -8,
    marginBottom: 16,
  },
  blankSpace: {
    width: 40,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    alignSelf: 'center',
    lineHeight: 32,
    width: 260,
    marginBottom: 40,
  },
})
